import Vue from 'vue';
import browserDetect from "vue-browser-detect-plugin";

Vue.use(browserDetect); 